<template>
    <div class="hello">
        <div>
            <ul class="menu-li-item">
                <li v-for="(item,index) in list">
                    <div class="menu-li-title">
                        {{index + 1}}
                        <div style="width:30%;display:inline-block;">{{item.titleName}}</div>   
                        <div style="width:30%;display:inline-block;">{{item.permissionId}}</div> 
                        <div style="width:30%;display:inline-block;"><span @click="delmenu(item.permissionId)" class="menu-del">删除</span>  &nbsp; <span @click="edit(item.permissionId)"  class="menu-del">编辑</span></div>
                    </div>
                    <div v-if="item.children && item.children.length>0" v-for="(child,i) in item.children">
                        <div>
                            <div style="width:30%;display:inline-block;">--{{child.titleName}}</div>   
                            <div style="width:30%;display:inline-block;">{{child.permissionId}}</div> 
                            <div style="width:30%;display:inline-block;"><span @click="delmenu(child.permissionId)">删除</span>  &nbsp; <span @click="edit(child.permissionId)">编辑</span></div>
                        </div>
                        <div v-if="child.children && child.children.length>0" v-for="(children,j) in child.children">
                            <div style="width:30%;display:inline-block;">----{{children.titleName}}</div>   
                            <div style="width:30%;display:inline-block;">{{children.permissionId}}</div> 
                            <div style="width:30%;display:inline-block;"><span @click="delmenu(children.permissionId)">删除</span>  &nbsp; <span@click="edit(children.permissionId)">编辑</span></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div style="width:100%;height:2px;background-color:#dbdbdb;margin-bottom:10px;margin-top:10px;">

        </div>
        <div class="menu-list">
            <div>
                菜单名称titlename <Input v-model="titleName" placeholder="" size="large" style="max-width:20%;"/>
            </div>
            <div>
                跳转地址url <Input v-model="url" placeholder="" style="max-width:20%;" size="large"/>
            </div>
            <div>
                组件地址component <Input v-model="component" placeholder="" style="max-width:20%;" size="large"/>
            </div>
            <div>
                组件componentName<Input v-model="componentName" placeholder="" style="max-width:20%;" size="large"/>
            </div>
            <div>
                重定向地址redirect<Input v-model="redirect" placeholder="" style="max-width:20%;" size="large"/>
            </div>
            <div>
                排序sortNo<Input v-model="sortNo" placeholder="" style="max-width:20%;" size="large"/>
            </div>
            <div>   
                菜单类型menutype<Input v-model="menutype" placeholder="" style="max-width:20%;" size="large"/>(0:一级菜单; 1:子菜单:2:按钮权限)
                 <!-- <Select v-model="menutype" size="middle" style="max-width:20%;">
                            <Option v-for="(item,index) in menutypelist" :value="index" :key="item">{{ item }}</Option>
                    </Select> -->
            </div>
            <div>
                父级菜单parentId<Input v-model="parentId" placeholder="" style="max-width:20%;" size="large"/>
                <!-- <Select v-model="parentId" size="middle" style="max-width:20%;">
                            <Option v-for="(item,index) in parentlist" :value="index" :key="item">{{ item }}</Option>
                       </Select> -->
            </div>
            <div>
                是否叶子（无子节点）<Input v-model="isLeaf" placeholder="" style="max-width:20%;" size="large"/>（1不查下级，0查）
            </div>
            <div>
                是否隐藏路由<Input v-model="hidden" placeholder="" style="max-width:20%;" size="large"/>（1隐藏，0不隐藏）
            </div>
            <div>
                是否有显示的子路由<Input v-model="hasChildrenShow" placeholder="" style="max-width:20%;" size="large"/>（1有显示，0没有显示）
            </div>
            <div>
                菜单id<Input v-model="id" placeholder="" style="max-width:20%;" size="large"/>（1有显示，0没有显示）
            </div>
            <button @click="creatmenu" class="but">
                创建
            </button>
            
        </div>
    </div>
</template>

<script>
import {creatmenu,deletmenu,menulist,getmenuinfo,editmenu,getmenu} from '@/api/axios'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data(){
      return{
        list:[],
        upobj:{},
        menutype:'',//菜单类型(0:一级菜单; 1:子菜单:2:按钮权限)
        menutypelist:['一级菜单','子菜单','按钮权限'],
        name:'',//组件name
        parentId:"",//父id
        parentlist:[],
        titleName:"",//标题
        url:"",//跳转地址
        component:"",//组件地址
        componentName:"",//组件名字
        redirect:'',//重定向地址
        perms:"",//菜单权限编码
        sortNo:'',//菜单排序
        icon:"",//图标
        isLeaf:"",//是否叶子（无子节点）（1是，0否）
        description:"",//描述
        hidden:'',//是否隐藏路由1是0否
        sortNo:'',//排序
        hasChildrenShow:'',//是否有显示的子路由1是0否
        id:'',
      }
      
  },
  mounted(){
      this.getlist();
  },
  methods:{
    creatmenu(){//创建菜单 权限按钮  编辑菜单
        let updata={};
        if(this.menutype!=2){
            updata['menuType']=this.menutype;
            updata['titleName']=this.titleName;
            updata['url']=this.url;
            updata['component']=this.component;
            updata['componentName']=this.componentName;
            updata['redirect']=this.redirect?this.redirect:null;
            updata['sortNo']=this.sortNo;
            updata['isLeaf']=this.isLeaf;
            updata['hidden']=this.hidden;
            updata['sortNo']=this.sortNo;
            updata['hasChildrenShow']=this.hasChildrenShow;
            updata['alwaysShow']='';//"聚合子路由"
            updata["icon"]='';//"菜单图标"
            updata["isRoute"]='1';
            if(this.parentId){
                updata['parentId']=this.parentId;
            }
            if(this.id){
                updata["permissionId"]=this.id
            }
            if(this.menutype===0){
            
            }
            if(this.id){
                editmenu(updata).then(res=>{
                    if(res.data.success){
                        this.getlist();
                        this.id='';
                    }
                })
            }else{
                creatmenu(updata).then(res=>{
                    if(res.data.success){
                        this.getlist();
                    }
                })
            }
            
        }   
    },
    getlist(){
        menulist().then(res=>{
            if(res.data.success){
                this.list=res.data.result;
                getmenu().then(res=>{
                    if(res.data.success){
                        sessionStorage.menu=JSON.stringify(res.data.result.menu);
                    }
                })        
            }
        })
    },
    delmenu(id){
        deletmenu(id).then(res=>{
            if(res.data.success){
                this.getlist();
            }
        })
    },
    edit(id){
        getmenuinfo(id).then(res=>{
            if(res.data.success){
                let updata=res.data.result
                this.upobj=res.data.result;
                this.menutype=updata['menuType'];
                this.titleName=updata['titleName'];
                this.url=updata['url'];
                this.component=updata['component'];
                this.componentName=updata['componentName'];
                this.redirect=updata['redirect'];
                this.sortNo=updata['sortNo'];
                this.isLeaf=updata['isLeaf'];
                this.hidden=updata['hidden'];
                this.sortNo=updata['sortNo'];
                this.hasChildrenShow=updata['hasChildrenShow'];
                this.id=updata['permissionId'];
                this.parentId=updata['parentId'];
            }
        })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .menu-list{
        padding:0 10px;
    }
    .menu-list>div{
        padding:5px 0;
        border-bottom: solid 1px #edecef;
    }
    .but{
        width:120px;
        height:40px;
        line-height:40px;
        text-align:center;
        margin:20px 0;
    }
    .menu-li-item li{
        width:90%;
        line-height:30px;
        margin:10px;
        border:solid 1px #edecef;
        overflow:hidden;
        padding:10px;
    }
    .menu-li-title{
        font-weight:bold;
        padding:10px 0;
    }
    .menu-del{
        display:inline-block;
        background:#2f72f5;
        color:#fff;
        padding:2px 20px;
        border-radius:3px;
        margin-right:9px;
        font-size:12px;
    }
</style>
